"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplayMode = exports.REPLAY_ROUND_START = exports.REPLAY_ROUND_LAUNCH = exports.REPLAY_ROUND_END = exports.REPLAY_ROUND_DEMO = exports.REPLAY_ROUND = void 0;
var ReplayMode = exports.ReplayMode = /*#__PURE__*/function (ReplayMode) {
  ReplayMode[ReplayMode["Replay"] = 0] = "Replay";
  ReplayMode[ReplayMode["ReplayLaunch"] = 1] = "ReplayLaunch";
  ReplayMode[ReplayMode["Demo"] = 2] = "Demo";
  return ReplayMode;
}({});
var REPLAY_ROUND = exports.REPLAY_ROUND = "REPLAY_ROUND";
var REPLAY_ROUND_START = exports.REPLAY_ROUND_START = "REPLAY_ROUND_START";
var REPLAY_ROUND_END = exports.REPLAY_ROUND_END = "REPLAY_ROUND_END";
/**
 * Game was launched for just watching a replay. no real playing.
 */
var REPLAY_ROUND_LAUNCH = exports.REPLAY_ROUND_LAUNCH = "REPLAY_ROUND_LAUNCH";
/**
 * Watching a demo/feature round.
 */
var REPLAY_ROUND_DEMO = exports.REPLAY_ROUND_DEMO = "REPLAY_ROUND_DEMO";
//# sourceMappingURL=types.js.map